var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "ma-0 pa-2 mt-2",
      attrs: { width: "100%", elevation: "0", outlined: "" },
    },
    [
      _c("v-card-title", { staticClass: "blue--text pa-0 ma-0 ml-1 mb-2" }, [
        _vm._v("Ball"),
      ]),
      _c(
        "v-row",
        { attrs: { dense: "" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", sm: "4", md: "4" } },
            [
              _c("v-text-field", {
                attrs: { label: "Key", "hide-details": "" },
                model: {
                  value: _vm.value.key,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.value,
                      "key",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "value.key",
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4", sm: "4" } },
            [
              _c("r-currency-kind-dropdown", {
                attrs: { model: _vm.value.currency },
                on: {
                  "update:model": function ($event) {
                    return _vm.$set(_vm.value, "currency", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-col",
            { staticClass: "mx-3", attrs: { cols: "12", sm: "2", md: "2" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "my-1 fill-width",
                  attrs: { small: "", color: "success" },
                  on: { click: _vm.onPhysicsConfig },
                },
                [_vm._v(" Physics Config ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("r-plinko-physics-config-dialog", { ref: "r-plinko-physics-config" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }